import { getPublicSiteUrl, SHORT_LINK_PATH_PREFIX } from '../../config/publicSite'

export const buildShortPath = (shortSlug = '') => (shortSlug ? `${SHORT_LINK_PATH_PREFIX}/${shortSlug}` : '')

export const buildShortUrl = (shortSlug = '') => {
  const shortPath = buildShortPath(shortSlug)

  if (!shortPath) {
    return ''
  }

  return `${getPublicSiteUrl()}${shortPath}`
}

export const buildShortLinkFields = (shortSlug = '') => ({
  short_slug: shortSlug || '',
  short_path: buildShortPath(shortSlug),
  short_url: buildShortUrl(shortSlug),
})

export default buildShortLinkFields
